import { render, staticRenderFns } from "./matchingSchools.vue?vue&type=template&id=1a17bf3b&scoped=true"
import script from "./matchingSchools.vue?vue&type=script&lang=js"
export * from "./matchingSchools.vue?vue&type=script&lang=js"
import style0 from "./matchingSchools.vue?vue&type=style&index=0&id=1a17bf3b&prod&scoped=true&lang=less"
import style1 from "./matchingSchools.vue?vue&type=style&index=1&id=1a17bf3b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a17bf3b",
  null
  
)

export default component.exports